customElements.get("localization-form") || customElements.define("localization-form", class extends HTMLElement {
  constructor() {
    super(), this.modal = this.closest(".modal"), this.modalToggle = this.modal.querySelector('input[type="checkbox"][data-locker]'), 
    this.form = this.querySelector("form"), this.languageWrapper = this.querySelector("[data-language-wrapper]"), 
    this.countryWrapper = this.querySelector("[data-country-selector-wrapper]"), this.config = JSON.parse(this.querySelector("script[data-language-config]").textContent || "[]") || {}, 
    this.data = JSON.parse(this.modal.querySelector("script[data-json]").textContent || "[]") || {}, 
    this.currentStore = this.dataset.storeCode;
  }
  async connectedCallback() {
    await ((e, t = 5e3) => new Promise(((a, s) => {
      const o = Date.now(), l = setInterval((() => {
        window[e] ? (clearInterval(l), a(window[e])) : Date.now() - o >= t && (clearInterval(l), 
        s(new Error(`'${e}' did not become available within ${t}ms.`)));
      }), 100);
    })))("Geo", 5e3), this.form && window.Geo && this.modal && this.addEventListeners();
  }
  update(e) {
    const t = e.target;
    if ("language_code" === t.name) {
      const e = t.selectedOptions[0];
      if (e) {
        const t = this.querySelector("[data-language-name]");
        t && (t.textContent = e.textContent);
      }
      return;
    }
    if ("country_code" !== t.name) return;
    const a = t.selectedOptions[0];
    if (!a) return void this.form.submit();
    this.querySelector("[data-name]") && (this.querySelector("[data-name]").textContent = a.textContent), 
    this.querySelector("[data-flag]") && (this.querySelector("[data-flag]").src = this.querySelector("[data-flag]").src.replace(/([a-z]{2})\.svg$/, `${a.value.toLowerCase()}.svg`)), 
    this.modal.querySelectorAll("[data-country-code]").forEach((e => {
      e.textContent = a.value;
    })), this.modal.querySelectorAll("[data-country-name]").forEach((e => {
      const t = this.data[a.value];
      t && (e.textContent = t?.name);
    }));
    const s = this.modal.querySelector("[data-usp-code].active");
    s && (s.classList.add("hidden"), s.classList.remove("active"));
    const o = this.modal.querySelector(`[data-usp-code="${a.value}"]`);
    if (o && (o.classList.remove("hidden"), o.classList.add("active")), !this.config) return;
    const l = e.target.value, r = this.querySelector('select[name="language_code"]');
    if (!r) return;
    const n = r.value, i = this.config.find((e => e.iso_code === l));
    i && (r.innerHTML = "", i.available_languages.forEach((e => {
      const t = document.createElement("option");
      t.value = e.iso_code, t.textContent = e.name, e.iso_code === n && (t.selected = !0), 
      r.appendChild(t);
    })), i.available_languages.length > 0 && !r.value && (r.value = i.available_languages[0].iso_code), 
    i.available_languages.length > 1 ? (this.languageWrapper.classList.remove("hidden"), 
    this.form.className = "flex flex-wrap gap-2xs px-offset pb-offset tablet:pb-lg", 
    this.countryWrapper.classList.add("flex-[1.8]"), this.countryWrapper.classList.remove("w-full")) : (this.languageWrapper.classList.add("hidden"), 
    this.form.className = "flex flex-wrap gap-2xs px-offset pb-offset tablet:pb-lg block w-grid [--columns:4] laptop:[--columns:2] m-auto tablet:w-full", 
    this.countryWrapper.classList.add("w-full"), this.countryWrapper.classList.remove("flex-[1.8]")));
  }
  addEventListeners() {
    this.modal.addEventListener("click", (e => {
      e.stopImmediatePropagation();
    })), this.form.addEventListener("change", (e => this.update(e))), this.form.addEventListener("submit", (e => {
      e.preventDefault(), this.form.submit();
    })), this.modalToggle && this.modalToggle.addEventListener("change", (() => {
      this.modalToggle.checked || document.body.classList.remove("attentive-hide");
    }));
  }
});